import { Icon } from "@iconify/react";
import React from "react";
import Text from "./Text";
import Button from "./Button";

const EmptyView = (props) => {
  const icon = props?.icon;
  const text = props?.text;
  const info = props?.info;
  const withWrapper = props?.withWrapper;
  const buttonProps = props?.buttonProps;

  const renderEmptyView = () => {
    return (
      <div
        className={`flex bg-orange w-[85%] rounded-button self-center items-center justify-center h-60 flex-col`}
      >
        <Icon className="w-16 h-16 pb-6 text-white" icon={icon || ""} />
        <Text bold white text={text || ""} className="px-2" center />
        {info && info !== "" ? (
          <Text bold white text={info} className="px-2 mt-2" center />
        ) : null}
        {buttonProps ? <Button className="mt-5" {...buttonProps} /> : null}
      </div>
    );
  };
  const renderEmptyWrapper = () => {
    return withWrapper ? (
      <div className="min-h-screen flex justify-center items-start mt-8">
        {renderEmptyView()}
      </div>
    ) : (
      renderEmptyView()
    );
  };
  return renderEmptyWrapper();
};
export default EmptyView;
